import secureLocalStorage from "react-secure-storage";

import * as api from "middlewares/apis";
import { requestForToken } from "middlewares/firebase";

import dexieDB from "database/dexieDB";

export const updateAllAccountsInNotificationDevice = (notify) => async (dispatch) => {
	const currentUser = secureLocalStorage.getItem("currentUser");
	let accounts = [];

	try {
		const deviceToken = await requestForToken();

		const deviceInfo = await dexieDB.deviceInfo
			.orderBy("id")
			.first()
			.then((data) => {
				if (data?.data) return data.data;
				else return null;
			});

		if (deviceInfo?.["device-id"]) {
			const userData = await dexieDB.tAlgoAccounts
				.filter((item) => item?.userID === currentUser?._id)
				.first()
				.then((data) => {
					if (data?.data) {
						return data.data;
					} else return null;
				});

			for (let account of userData) {
				accounts.push({ "account-address": account?.["account-address"], ...account?.["notification-preferences"] });
			}

			await api.updateAllAccountsInNotificationDevice({
				"device-id": deviceInfo["device-id"],
				"device-token": deviceToken,
				"device-type": "Browser",
				"device-model": `${deviceInfo?.["osName"]}-${deviceInfo?.["osVersion"]} (${deviceInfo["browserName"]}-${deviceInfo["browserFullVersion"]})`,
				accounts: accounts,
			});
		} else {
			notify("warning", "Device failed to register for notifications");
		}
	} catch (error) {
		console.error(error);
	}
};

export const removeAllAccountsInNotificationDevice = async (notify) => {
	try {
		const deviceInfo = await dexieDB.deviceInfo
			.orderBy("id")
			.first()
			.then((data) => {
				if (data?.data) return data.data;
				else return null;
			});

		await api.getNotificationDeviceByID(deviceInfo["device-id"]).then(async ({ data }) => {
			if (data?.data?.["device-id"]) {
				await api
					.updateAllAccountsInNotificationDevice({
						"device-id": deviceInfo["device-id"],
						accounts: [],
					})
					.then((data) => {
						if (!data) notify("warning", "Device failed to un-register for notifications");
					});
			} else {
				notify("warning", "Device not found while un-register for notification");
			}
		});
	} catch (error) {
		console.error(error);
	}
};
